import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from 'styled-components';
import Box from '../Box';
import { useThemeDefaults } from '../utils';

var hrStyle = function hrStyle(props) {
  return {
    border: "none",
    marginTop: props.sa || props.mt ? undefined : "0",
    marginBottom: props.sb || props.mb ? undefined : "0"
  };
};

var HR = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return _objectSpread(_objectSpread({}, Box.defaultProps), {}, {
    as: 'hr',
    bg: theme.hrColor,
    height: '1px'
  });
}, styled(Box).withConfig({
  displayName: "HR",
  componentId: "sc-jf2ll2-0"
})(hrStyle));
HR.propTypes = _objectSpread({}, Box.propTypes);
export default HR;